export const COLUMNS = [
    {
        header: "Event Name",
        accessor: "name",
    },
    {
        header: "Type",
        accessor: "eventType",
        render: (data: any) => data?.eventType || "AHC",
    },
    {
        header: "Coupon",
        accessor: "couponCode",
        render: (data: any) => data?.couponCode || "--",
    },
    {
        header: "Packages",
        accessor: "packages",
        render: (data: any) => Array.isArray(data?.packages)
            ? data.packages.map((item: any) => item.displayName).join(", ")
            : "--",
    },
    {
        header: "Registered",
        accessor: "registeredUsers",
        render: (data: any) => data?.stats?.registeredUsers ?? 0,
    },
    {
        header: "Booked Users",
        accessor: "bookedUsers",
        render: (data: any) => data?.stats?.bookedUsers ?? 0,
    },
    {
        header: "Attended",
        accessor: "attendedUsers",
        render: (data: any) => data?.stats?.attendedUsers ?? 0,
    },
    {
        header: "Active",
        accessor: "isActive",
        render: (data: any) => data?.isActive === false ? "No" : "Yes",
    },
]
